'use client'

import { useCallback } from 'react'

import { usePortalOnboardingPersistence } from '@apps/portal-onboarding/hooks'
import { usePortalOnboardingStore } from '@apps/portal-onboarding/stores/portal-onboarding.store'

export function usePortalOnboardingDismiss() {
  const dismiss = usePortalOnboardingStore((state) => state.dismiss)
  const { markDismissed } = usePortalOnboardingPersistence()

  return useCallback(() => {
    markDismissed()
    dismiss()
  }, [dismiss, markDismissed])
}
